import { AM, DAY_IN_HOURS, HALF_AMPM_DAY, PM } from 'consts';

export const validateCustomRemoteLevel = (
  customRemoteLevel: {
    allowedOverlap: number | '';
    workingDayStartAmPm: string;
    workingDayStartHours: number;
    workingDayEndAmPm: string;
    workingDayEndHours: number;
  },
  workingHoursCount: number
) => {
  const {
    allowedOverlap,
    workingDayStartAmPm,
    workingDayStartHours,
    workingDayEndAmPm,
    workingDayEndHours,
  } = customRemoteLevel;

  const isAmpmSame = workingDayStartAmPm === workingDayEndAmPm;

  const validateWorkingDayStartHours = () => {
    if (
      !workingDayStartHours ||
      workingDayStartHours < 1 ||
      workingDayStartHours > HALF_AMPM_DAY
    ) {
      return 'value should be 1-12';
    }

    return '';
  };

  const validateWorkingDayEndHours = () => {
    if (isAmpmSame) {
      const isInRange = workingHoursCount <= DAY_IN_HOURS - 1;

      if (!isInRange) {
        const oppositeAmPm = workingDayStartAmPm === AM ? PM : AM;
        const maxPossibleEndDayHour = workingDayEndHours - 1;
        const maxWorkingDayEndHoursValue =
          maxPossibleEndDayHour > 0
            ? `${maxPossibleEndDayHour}${workingDayStartAmPm}`
            : `${HALF_AMPM_DAY}${oppositeAmPm}`;

        return `Max value is ${maxWorkingDayEndHoursValue}`;
      }
    }

    if (
      !workingDayEndHours ||
      workingDayEndHours < 1 ||
      workingDayEndHours > HALF_AMPM_DAY
    ) {
      return 'value should be 1-12';
    }

    return '';
  };

  const validateAllowedOverlap = () => {
    if (
      allowedOverlap === '' ||
      allowedOverlap < 0 ||
      allowedOverlap > workingHoursCount
    ) {
      return `value should be 0-${workingHoursCount}`;
    }

    return '';
  };

  return {
    workingDayEndHours: validateWorkingDayEndHours(),
    workingDayStartHours: validateWorkingDayStartHours(),
    allowedOverlap: validateAllowedOverlap(),
  };
};
